module.exports = __webpack_public_path__ + "img/9870771.png";